:root {
  color: #172033;
  background: #f4f6fa;
  font-synthesis: none;
  text-rendering: optimizeLegibility;
}

body {
  margin: 0;
  min-width: 320px;
  min-height: 100vh;
}

.page-shell {
  width: min(100%, 1600px);
  margin: 0 auto;
}

.page-shell h2.ant-typography {
  margin-bottom: 4px;
}

.page-alert,
.section-card {
  margin-bottom: 16px;
}

.section-card {
  margin-top: 16px;
}

.subsection-title {
  margin-top: 24px !important;
}

.admin-header {
  min-height: 64px;
  padding: 0 24px;
  border-bottom: 1px solid #e7eaf0;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(12px);
}

.brand-title {
  color: #2457d6;
  font-size: 17px;
  letter-spacing: -0.02em;
}

.json-editor,
.compact-json {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
}

.compact-json {
  display: block;
  max-width: 880px;
  overflow: hidden;
  color: #3c4860;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sign-in-shell {
  min-height: 100vh;
  display: grid;
  place-content: center;
  gap: 28px;
  padding: 32px;
  background:
    radial-gradient(
      circle at top left,
      rgba(36, 87, 214, 0.16),
      transparent 34rem
    ),
    #f4f6fa;
}

.sign-in-copy {
  text-align: center;
}

@media (max-width: 720px) {
  .page-shell {
    padding: 0;
  }

  .admin-header {
    padding: 0 16px;
  }
}
